export const FETCH_PROVINCES_BY_CITY_START = "FETCH_PROVINCES_BY_CITY_START";
export const FETCH_PROVINCES_BY_CITY_SUCCESS = "FETCH_PROVINCES_BY_CITY_SUCCESS";
export const FETCH_PROVINCES_BY_CITY_FAIL = "FETCH_PROVINCES_BY_CITY_FAIL";

export const FETCH_PROVINCE_BY_ID_START = "FETCH_PROVINCE_BY_ID_START";
export const FETCH_PROVINCE_BY_ID_SUCCESS = "FETCH_PROVINCE_BY_ID_SUCCESS";
export const FETCH_PROVINCE_BY_ID_FAIL = "FETCH_PROVINCE_BY_ID_FAIL";
